/**
 * root splat ルート — 未マッチ URL のフォールバック。
 *
 * 背景: coco+(145) の旧ネイティブビルド(v1.1未満)は購入ページへ遷移する
 * `window.location.href = "/cocoplus_point_package1"` を URL インターセプトできず、
 * WebView がそのままこの URL に着地してしまう。
 *
 * このルートは `/cocoplus_point_package*`（アンダースコア無し）パターンに
 * マッチした場合のみ購入ページへリダイレクトし、保険として機能する。
 * OTA 適用済みの新ビルドでは native がインターセプト済みのためこのルートは発火しない。
 *
 * 購入パターンにマッチしない URL は従来どおり notFound() で 404 扱いにする。
 */
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

/** 購入パッケージ URL パターン（アンダースコアあり・なし両方対応） */
const PURCHASE_PACKAGE_PATTERN = /_?point_package_?\d+/;

export const Route = createFileRoute("/$")({
  beforeLoad: ({ params }) => {
    const splat = params._splat ?? "";
    if (PURCHASE_PACKAGE_PATTERN.test(splat)) {
      throw redirect({ to: "/purchase" });
    }
    throw notFound();
  },
});
